import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login'
import Utilizatori from '../views/Utilizatori'
import Statistici from '../views/Statistici.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/utilizatori',
    meta: {
      auth: true,
      role: 'admin'
    },
    name: 'utilizatori',
    component: Utilizatori
  },
  {
    path: '/pacienti',
    meta: {
      auth: true
    },
    component: () => import('../views/Pacienti.vue'),
    children: [
      {
        path: '',
        meta: {
          auth: true
        },
        component: () => import('../views/ListPacienti.vue')
      },
      {
        path: 'list',
        meta: {
          auth: true
        },
        name: 'list-pacients',
        component: () => import('../views/ListPacienti.vue')
      },
      {
        path: 'add',
        meta: {
          auth: true
        },
        name: 'add-patient',
        component: () => import('../views/AddPacient.vue')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'edit',
        component: () => import('../views/AddPacient.vue')
      },
      {
        path: 'programari/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'programari',
        component: () => import('../views/Programari.vue')
      },
      {
        path: 'docs/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'docs',
        component: () => import('../views/DocsHistory.vue')
      },
      {
        path: 'history/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'history',
        component: () => import('../views/HistoryPacient.vue')
      },
      {
        path: 'schita/:id',
        meta: {
          auth: true,
          header: true
        },
        name: 'schita',
        component: () => import('../views/SchitaDentara.vue')
      }
    ]
  },
  {
    path: '/sterilizare',
    meta: {
      auth: true,
      role: 'sterilizare'
    },
    component: () => import('../views/Instrumente.vue')
  },
  {
    path: '/reviews',
    meta: { auth: true },
    component: () => import('../views/Reviews.vue')
  },
  {
    name: 'Statistici',
    path: '/statistici',
    meta: { auth: true },
    component: () => import('../views/Statistici.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    store.state.isLogged ? next('/pacienti') : next()
  } else {
    to.meta.auth && !store.state.isLogged
      ? store.dispatch('checkLogin', {to, next})
      : next()
  }
})

export default router
